import React from 'react'
import { t } from '../../../i18n'
import { CommandButton, ControlGroupKey } from '../types'
import ActionButton from './ActionButton'

const scope = 'controls'

interface Props {
  groupKey: ControlGroupKey
  commands: CommandButton[]
}

const DoorsLayout = ({ groupKey, commands }: Props) => {
  const findPair = (unlockName: string, lockName: string) => {
    const unlock = commands.find(c => c.command === unlockName)
    const lock = commands.find(c => c.command === lockName)
    return [unlock, lock].filter((b): b is CommandButton => Boolean(b))
  }

  const accessPair = findPair('unlock_access_doors', 'lock_access_doors')
  const feedersBowlsPair = findPair('unlock_feeders_and_bowls_doors', 'lock_feeders_and_bowls_doors')

  const all = [...accessPair, ...feedersBowlsPair]

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title mb-3">{t(`groups.${groupKey}`, { scope })}</h6>
        {commands.length === 0 ? (
          <div className="text-muted fst-italic">—</div>
        ) : (
          <div className="controls-actions-grid-two">
            {all.map(c => (
              <ActionButton key={c.name} command={c} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default DoorsLayout
